var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFcStudentLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.525 4.075L8.525 0.075C8.225 -0.025 7.825 -0.025 7.525 0.075L0.525 4.075C-0.175 4.475 -0.175 5.475 0.525 5.775L7.525 9.775C7.825 9.975 8.225 9.975 8.525 9.775L15.525 5.775C16.225 5.475 16.225 4.475 15.525 4.075Z",
    fill: "var(--fill-0, #86B4F9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.525 11.575C9.025 11.875 8.525 11.975 8.025 11.975C7.525 11.975 7.025 11.875 6.525 11.575L2.025 8.975V12.975C2.025 15.075 5.125 15.975 8.025 15.975C10.925 15.975 14.025 15.075 14.025 12.975V8.975L9.525 11.575Z",
    fill: "var(--fill-0, #86B4F9)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcStudentLoan);
export default __webpack_public_path__ + "static/media/fc-student-loan.924195de4ea461f458456b88299457c9.svg";
export { ForwardRef as ReactComponent };